import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  PendingBulkTakedownItem,
  PendingBulkTakedownKey,
  PendingBulkTakedownsState,
} from './types';

const initialState: PendingBulkTakedownsState = {
  items: [],
};

// Results normally arrive within seconds; anything older than this never got
// one (request-level failure, WS outage) and is dropped on the next enqueue.
export const PENDING_BULK_TAKEDOWN_TTL_MS = 10 * 60 * 1000;

const sameKey = (a: PendingBulkTakedownKey, b: PendingBulkTakedownKey) =>
  a.attackId === b.attackId && a.brandId === b.brandId;

const pendingBulkTakedownsSlice = createSlice({
  name: 'pendingBulkTakedowns',
  initialState,
  reducers: {
    addPendingBulkTakedowns: (
      state,
      action: PayloadAction<PendingBulkTakedownItem[]>,
    ) => {
      const cutoff = Date.now() - PENDING_BULK_TAKEDOWN_TTL_MS;
      const fresh = state.items.filter(
        item =>
          new Date(item.startedAt).getTime() > cutoff &&
          !action.payload.some(added => sameKey(added, item)),
      );
      state.items = [...fresh, ...action.payload];
    },
    removePendingBulkTakedowns: (
      state,
      action: PayloadAction<PendingBulkTakedownKey[]>,
    ) => {
      state.items = state.items.filter(
        item => !action.payload.some(removed => sameKey(removed, item)),
      );
    },
  },
});

export const { addPendingBulkTakedowns, removePendingBulkTakedowns } =
  pendingBulkTakedownsSlice.actions;

export default pendingBulkTakedownsSlice.reducer;
